// DEPLOY: /var/www/woody.wtf/frontend/src/chart/theme.js
// woody.wtf chart engine: colours come from the site's CSS variables (index.css),
// so the chart follows the site palette. User themes will override these later.
export function readTheme(el) {
  const s = getComputedStyle(el || document.documentElement);
  const v = (name, fallback) => s.getPropertyValue(name).trim() || fallback;
  return {
    bg:     v('--surface', '#FFFFFF'),
    grid:   v('--border', '#E4E4E0'),
    text:   v('--text', '#1A1A1A'),
    muted:  v('--text-muted', '#6B6B6B'),
    accent: v('--accent', '#7C3AED'),
    up:     v('--success', '#16A34A'),
    down:   v('--error', '#DC2626'),
    candleLine: '#000000',   // wicks + body outline
    live:   '#9333EA',       // today's unconfirmed candle (purple) until the EOD bar arrives
    font:   "11px 'DM Mono', monospace",
  };
}
